import { render, staticRenderFns } from "./electricity.vue?vue&type=template&id=4eef85e8&scoped=true&"
import script from "./electricity.vue?vue&type=script&lang=js&"
export * from "./electricity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eef85e8",
  null
  
)

export default component.exports